import { useToggle } from '../useToggle/useToggle.es.js';

function useVisible(initialState) {
  if (initialState === void 0) {
    initialState = false;
  }

  var _useToggle = useToggle(initialState),
      visible = _useToggle.isActive,
      show = _useToggle.activate,
      hide = _useToggle.deactivate,
      toggle = _useToggle.toggle;

  return {
    visible: visible,
    show: show,
    hide: hide,
    toggle: toggle
  };
}

export { useVisible };